import React, { useState, useEffect } from 'react';
import axios from 'axios';
import link from '../link';
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import { Button } from 'react-bootstrap';
import Select from 'react-select'

function AddUserLogin() {
    let param = useParams();
    const [organizationName, setOrganizationName] = useState('');
    const [organizationError, setOrganizationError] = useState('');
    const [loginId, setLoginId] = useState('');
    const [loginIdError, setLoginIdError] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phone, setPhone] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [fmcLst, setFmcLst] = useState([{ label: "Select", value: '0' }, { label: "Select1", value: '1' }]);
    const [fmcIds, setFmcIds] = useState('');
    const [fmcIdsError, setFmcIdsError] = useState('');
    const [active, setActive] = useState(true);
    const [logo, setLogo] = useState(null);
    const [logoError, setLogoError] = useState(null);
    const [finImg, setFinImg] = useState(null);
    const [extension, setExtension] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const token = sessionStorage.getItem('token');
        const usertype = sessionStorage.getItem('usertype');
        if (token !== '' && usertype === 'user') {
            // console.log(token, usertype);
            navigate('/');
        } else if (token === undefined && usertype === 'admin') {
            navigate('/admin');
        }
        // console.log(param);
        axios.get(`${link.apiUrl1}/api/fmcuser/all/fmc/users`).then(res => {
            // console.log(res.data);
            let fmcdata = []
            for (let i = 0; i < res.data.length; i++) {
                fmcdata.push({
                    label: res.data[i].name,
                    value: res.data[i]._id
                })
            }
            setFmcLst(fmcdata);
        })
        var size = Object.keys(param).length;
        // console.log(size);
        if (size > 0) {
            axios.get(`${link.apiUrl}/api/misdashboardlogin/${param.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': JSON.parse(token),
                }
            }).then(response => {
                // console.log(response.data);
                setFmcIds(response.data.fmcIds.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())));
                setOrganizationName(response.data.organizationName);
                setLoginId(response.data.loginId);
                setEmail(response.data.email);
                setPhone(response.data.phone);
                setActive(response.data.is_active);
                setLogo(response.data?.avtar || null)
            })
        }
    }, []);

    const handleInput = (e) => {
        const { name, value } = e.target;
        if (name === 'organizationName') {
            setOrganizationName(value)
            if (value !== '') setOrganizationError('')
        };
        if (name === 'loginId') { setLoginId(value); if (value !== '') setLoginIdError('') };
        if (name === 'email') setEmail(value);
        if (name === 'phone') if (/^\d+$/.test(value) || value === '') {
            setPhone(value);
            if (value !== '') setPhoneError('')
        }
    }

    const handleMultiSelect = (opt) => {
        setFmcIds(opt);
        if (opt.length > 1) {
            setFmcIdsError('');
        }
    }

    const submitData = () => {
        const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (organizationName === '') {
            setOrganizationError('Please enter organization name')
        }
        if (loginId === '') {
            setLoginIdError('Please enter login Id')
        }
        if (phone === '') {
            setPhoneError('Please enter phone number')
        }
        if (phone.length !== 10) {
            setPhoneError('Please Enter a Valid Mobile Number! Should Have 10 Numbers')
        }
        if (fmcIds.length === 0) {
            setFmcIdsError('Please Select at least one fmc')
        }

        if (logo === null) {
            setLogoError('Please upload logo for user')
        }

        if (regexp.test(email) === false) {
            setEmailError('Please enter a valid email address')
            // console.log('error')
        }
        if (regexp.test(email) === true && organizationName !== '' && loginId !== '' && phone !== '' && phone.length === 10 && fmcIds.length > 0) {
            setEmailError('');
            setOrganizationError('');
            setLoginIdError('');
            setPhoneError('');
            setFmcIdsError('');
            setLogoError('')
            let token = JSON.parse(sessionStorage.getItem('token'))
            // console.log('success');
            if (finImg !== null) {
                let form = new FormData();
                form.append('avtar', finImg);
                axios.post(`${link.apiUrl}/api/misdashboardlogin/images`, form, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-auth-token': token,
                    }
                }).then(res => {
                    // console.log(res.data)
                    const data = {
                        organizationName: organizationName,
                        email: email,
                        phone: phone,
                        fmcIds: fmcIds,
                        loginId: loginId,
                        is_active: active,
                        avtar: res.data
                    }
                    if (Object.keys(param).length === 0) {
                        axios.post(`${link.apiUrl}/api/misdashboardlogin`, data, {
                            headers: {
                                'Content-Type': 'application/json',
                                'x-auth-token': token,
                            }
                        }).then(response => {
                            if (response.data.status === 'Success') {
                                navigate('/userlogin');
                            }
                        })
                    } else {
                        let token = JSON.parse(sessionStorage.getItem('token'))
                        axios.put(`${link.apiUrl}/api/misdashboardlogin/${param.id}`, data, {
                            headers: {
                                'Content-Type': 'application/json',
                                'x-auth-token': token,
                            }
                        }).then(response => {
                            if (response.data.status === 'Success') {
                                navigate('/userlogin');
                            }
                        })
                    }
                })
            } else {
                const data = {
                    organizationName: organizationName,
                    email: email,
                    phone: phone,
                    fmcIds: fmcIds,
                    loginId: loginId,
                    is_active: active,
                    avtar: logo
                }
                if (Object.keys(param).length === 0) {
                    axios.post(`${link.apiUrl}/api/misdashboardlogin`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'x-auth-token': token,
                        }
                    }).then(response => {
                        if (response.data.status === 'Success') {
                            navigate('/userlogin');
                        }
                    })
                } else {
                    let token = JSON.parse(sessionStorage.getItem('token'))
                    axios.put(`${link.apiUrl}/api/misdashboardlogin/${param.id}`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'x-auth-token': token,
                        }
                    }).then(response => {
                        if (response.data.status === 'Success') {
                            navigate('/userlogin');
                        }
                    })
                }
            }

        }
    }

    const onFileChange = (e) => {
        const [name, extension] = e.currentTarget.files[0].type.split('/');
        if (
            extension === 'jpeg' ||
            extension === 'png'
        ) {
            let reader = new FileReader();
            reader.onloadend = () => setLogo(reader.result);
            reader.readAsDataURL(e.currentTarget.files[0]);
            setFinImg(e.currentTarget.files[0])
            setExtension(extension)
        } else {
            setLogo(null);
            setLogoError('Please select jpg, jpeg or png file to upload');
        }
    }

    return (
        <div>
            <div className="content">
                <div className="patientregistrationmain">
                    <div className="patientregistration">
                        <h2 className="dashboardtitleheadertext mb20">
                            {Object.keys(param).length === 0 ? 'Add User Login' : 'Update User Login'}
                        </h2>
                        <div className="row newrow" style={{ justifyContent: 'center' }}>
                            <div className="col-md-12">
                                <div className="boxshadow padding20">
                                    {/* <Button className='mb20 float-end' onClick={() => { console.log('add'); navigate('adduserlogin') }}>Add User</Button> */}
                                    {/* <h3 className="smallheading mb20">Add User</h3> */}
                                    <div style={{
                                        display: "flex",
                                        justifyContent: 'flex-start'
                                    }}>
                                        <input
                                            type="button"
                                            className="loginbluebtn mb20"
                                            onClick={() => navigate('/userlogin')}
                                            value="Go Back"
                                        />
                                    </div>
                                    <div className={`patientdetailsregisternumber custominput padding15 ${organizationError !== '' ? 'mb10' : 'mb20'}`}>
                                        <input
                                            type="text"
                                            name="organizationName"
                                            onChange={(e) => handleInput(e)}
                                            value={organizationName}
                                            placeholder="Enter Organization Name"
                                        />
                                    </div>
                                    {organizationError !== '' ? <div className='error text-start mb20'>{organizationError}</div> : null}
                                    <div className={`patientdetailsregisternumber custominput padding15 ${loginIdError !== '' ? 'mb10' : 'mb20'}`}>
                                        <input
                                            type="text"
                                            name="loginId"
                                            onChange={(e) => handleInput(e)}
                                            value={loginId}
                                            placeholder="Enter Login Id"
                                        />
                                    </div>
                                    {loginIdError !== '' ? <div className='error text-start mb20'>{loginIdError}</div> : null}
                                    <div className={`patientdetailsregisternumber custominput padding15 ${emailError !== '' ? 'mb10' : 'mb20'}`}>
                                        <input
                                            type="text"
                                            name="email"
                                            onChange={(e) => handleInput(e)}
                                            value={email}
                                            placeholder="Enter Email"
                                        />
                                    </div>
                                    {emailError !== '' ? <div className='error text-start mb20'>{emailError}</div> : null}
                                    <div className={`patientdetailsregisternumber custominput padding15 ${phoneError !== '' ? 'mb10' : 'mb20'}`}>
                                        <input
                                            type="text"
                                            maxLength={10}
                                            name="phone"
                                            onChange={(e) => handleInput(e)}
                                            value={phone}
                                            placeholder="Enter Phone"
                                        />
                                    </div>
                                    {phoneError !== '' ? <div className='error text-start mb20'>{phoneError}</div> : null}
                                    <div className={`testselectbox ${fmcIdsError !== '' ? 'mb10' : 'mb20'}`}>
                                        <Select
                                            isMulti
                                            closeMenuOnSelect={false}
                                            name="fmcIds"
                                            value={fmcIds}
                                            onChange={handleMultiSelect}
                                            options={fmcLst}
                                            placeholder="Select Fmc"
                                            styles={{
                                                menuList: (styles, { data }) => ({
                                                    ...styles,
                                                    height: '200px',
                                                    '::-webkit-scrollbar': {
                                                        width: '9px',
                                                        display: 'block',
                                                        WebkitTransition:
                                                            'background-color .2s linear, opacity .2s linear',
                                                    },
                                                    '::-webkit-scrollbar-track': {
                                                        background: 'transparent',
                                                    },
                                                    '::-webkit-scrollbar-thumb': {
                                                        background: '#888',
                                                        borderRadius: '5px',
                                                    },
                                                    '::-webkit-scrollbar-thumb:hover': {
                                                        background: '#555',
                                                    },
                                                }),
                                                multiValueLabel: (styles, { data }) => ({
                                                    ...styles,
                                                    textAlign: 'start',
                                                }),
                                                control: (styles, { data }) => ({
                                                    ...styles,
                                                    textAlign: 'start',
                                                }),
                                                menu: (styles, { data }) => ({
                                                    ...styles,
                                                    textAlign: 'start',
                                                }),

                                            }}
                                        />
                                    </div>
                                    {fmcIdsError !== '' ? <div className='error text-start mb20'>{fmcIdsError}</div> : null}

                                    <div className='mb30' style={{ textAlign: 'start' }}>
                                        <label
                                            htmlFor="file"
                                            style={{ fontWeight: 'bold' }}
                                        >Upload Logo</label>
                                        <br />
                                        {logo !== null && finImg !== null ? (
                                            extension === 'png' ||
                                                extension === 'jpeg' ? (
                                                <img
                                                    className="mb10"
                                                    src={logo}
                                                    alt=""
                                                />
                                            ) : null) : logo !== null && finImg === null ?
                                            <img
                                                className="mb10"
                                                src={`${link.cdnurl}/misdashboard/${logo}`}
                                                alt=""
                                            />
                                            : null}
                                        <br />
                                        <input type="file" name="file"
                                            id="file" onChange={onFileChange} accept="image/png, image/jpeg" />
                                        <br />
                                    </div>

                                    {logoError !== '' ? <div className='error text-start mb20'>{logoError}</div> : null}

                                    <div style={{ textAlign: 'start' }}>
                                        <input className="form-check-input" type="checkbox" checked={active} onChange={(e) => { setActive(!active) }} name='active' id="flexCheckDefault" />
                                        <label className="form-check-label pl10" htmlFor="flexCheckDefault">
                                            Active
                                        </label>
                                    </div>

                                    {Object.keys(param).length === 0 ? <input
                                        type="button"
                                        className="loginbluebtn width100per"
                                        onClick={() => submitData()}
                                        value="Add"
                                    /> : <input
                                        type="button"
                                        className="loginbluebtn width100per"
                                        onClick={() => submitData()}
                                        value="Update"
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddUserLogin;
